export enum TimeUnit { WEEKS="WEEKS", DAY="DAY", HOUR= "HOUR", MINUTES="MINUTES" }